import { render, staticRenderFns } from "./LessonCreate.vue?vue&type=template&id=066468b0&scoped=true"
import script from "./LessonCreate.vue?vue&type=script&lang=js"
export * from "./LessonCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066468b0",
  null
  
)

export default component.exports